<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="productDebugData">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="序列号">
            <el-input v-model.trim="filter.barCode" clearable/>
          </vm-search>
          <vm-search label="EID">
            <el-input v-model.trim="filter.eId" clearable/>
          </vm-search>
          <vm-search label="工单">
            <el-input v-model.trim="filter.orderNo" clearable/>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.techParamBillNo" clearable/>
          </vm-search>
          <vm-search label="合同号">
            <el-input v-model.trim="filter.clientContractNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column fixed prop="techParamBillNO" align="center" label="出厂编号"/>
      <el-table-column fixed prop="orderNo" align="center" label="工单号"/>
      <el-table-column fixed prop="clientContractNo" align="center" label="合同号"/>
      <el-table-column fixed prop="employeeNO" align="center" label="员工编号"/>
      <el-table-column fixed prop="barCode" align="center" label="序列号"/>
      <el-table-column fixed prop="testResult" align="center" label="测试结果"/>
      <el-table-column
          fixed
          width="180"
          prop="testTime"
          align="center"
          label="测试时间"/>
      <el-table-column fixed prop="totalDuration" align="center" label="测试时长"/>
      <el-table-column fixed prop="testWay" align="center" label="测试方式"/>
      <el-table-column fixed prop="eid" align="center" label="EID"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import KeyComponentEdit from "@/views/information/KeyComponent/KeyComponentEdit";
  export default {
    name: "",
    components: {VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          barCode: "",
          clientContractNo: "",
          startTime: "",
          endTime: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>

</style>
